// MUI Imports
import type { Theme } from '@mui/material/styles';

const MuiBadge: Theme['components'] = {
  MuiBadge: {
    styleOverrides: {
      badge: ({ theme, ownerState }) => {
        return {
          borderRadius: '50%',
          ...(ownerState.size === 'small' && {
            minWidth: '8px',
            height: '8px',
          }),
          ...(ownerState.size === 'medium' && {
            minWidth: '10px',
            height: '10px',
          }),
          ...(ownerState.size === 'large' && {
            minWidth: '12px',
            height: '12px',
          }),
          ...(ownerState.size === 'xLarge' && {
            minWidth: '16px',
            height: '16px',
          }),
          ...(ownerState.size === 'xxLarge' && {
            minWidth: '20px',
            height: '20px',
          }),
          ...(ownerState?.hasBorder
            ? {
                boxSizing: 'border-box',
                flexShrink: 0,
                border: '2px solid #FFFFFF',
              }
            : {}),
          ...(ownerState?.tonal
            ? {
                backgroundColor: theme.palette[ownerState?.color || 'primary']?.['opacity-16'],
              }
            : {}),
        };
      },
      standard: ({ theme, ownerState }) => ({
        color: ownerState?.tonal
          ? `${theme.palette[ownerState?.color || 'primary']?.main} !important`
          : 'white !important',
        height: 22,
        minWidth: 22,
        borderRadius: 20,
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: 1.07,
        padding: theme.spacing(1, 2),
      }),
    },
  },
};

export default MuiBadge;
